import {Component, Input, OnInit} from '@angular/core';
import {Warehouse, Warehouse2} from '../../../warehouse';
import {AbstractControl, FormBuilder, Validators} from '@angular/forms';
import {WarehouseParamsForm} from '../warehouse-params-form';
import {CintacValidators} from '../../../../_shared/cintac-validators';
import {WarehouseParamsFormService} from "app/project/project-form-components/warehouse-params-forms/warehouse-params-form.service";

@Component({
    selector: 'app-warehouse2-params-form',
    templateUrl: './warehouse2-params-form.component.html',
    styleUrls: ['../../project-form.css']
})
export class Warehouse2ParamsFormComponent implements OnInit, WarehouseParamsForm {
    @Input() warehouse: Warehouse2;
    isChanged: boolean;
    warehouseData: AbstractControl;
    supportConditions = Warehouse.getSupportConditions();
    inputFocus: string;

    formErrors: any;
    particularFormErrors = {
        'support_condition_central': '',
        'slope_1': '',
        'slope_2': '',
        'column_height': '',
        'width_1': '',
        'width_2': ''
    };

    validationMessages: any;
    particularValidationMessages = {
        'support_condition_central': {
            'required': 'Ingresar condición de apoyo.',
            'listValidator': CintacValidators.getSupportCondValidatorMessage()
        },
        'slope_1': {
            'required': 'Ingresar pendiente de cubierta 1.',
            'pattern': CintacValidators.getSlopeValidatorMessage()
        },
        'slope_2': {
            'required': 'Ingresar pendiente de cubierta 2.',
            'pattern': CintacValidators.getSlopeValidatorMessage()
        },
        'column_height': {
            'required': 'Ingresar altura de hombro.',
            'pattern': CintacValidators.getPositiveIntegerValidatorMessage()
        },
        'width_1': {
            'required': 'Ingresar luz 1.',
            'pattern': CintacValidators.getPositiveIntegerValidatorMessage()
        },
        'width_2': {
            'required': 'Ingresar luz 2.',
            'pattern': CintacValidators.getPositiveIntegerValidatorMessage()
        },
        'total_length': {
            'required': 'Largo total debe ser multiplo de la Distancia entre Marcos.',
            'pattern': CintacValidators.getPositiveIntegerValidatorMessage()
        }
    };

    constructor(private fb: FormBuilder, private warehouseFormService: WarehouseParamsFormService) {
        this.formErrors = this.warehouseFormService.getCommonFormErrors();
        Object.assign(this.formErrors, this.particularFormErrors);
        this.validationMessages = this.warehouseFormService.getCommonFormValidationMessages();
        Object.assign(this.validationMessages, this.particularValidationMessages);
        this.warehouseData = this.fb.group({
            frame_distance: [null, [Validators.required, CintacValidators.positiveIntegerValidator()]],
            total_length: [null, [Validators.required, CintacValidators.positiveIntegerValidator()]],
            support_condition_left: [null, [Validators.required, CintacValidators.supportCondValidator]],
            support_condition_right: [null, [Validators.required, CintacValidators.supportCondValidator]],
            support_condition_central: [null, [Validators.required, CintacValidators.supportCondValidator]],
            slope_1: [null, [Validators.required, CintacValidators.slopeValidator()]],
            slope_2: [null, [Validators.required, CintacValidators.slopeValidator()]],
            column_height: [null, [Validators.required, CintacValidators.positiveIntegerValidator()]],
            width_1: [null, [Validators.required, CintacValidators.positiveIntegerValidator()]],
            width_2: [null, [Validators.required, CintacValidators.positiveIntegerValidator()]]
        });
    }

    ngOnInit() {
        this.warehouseFormService.initWarehouseDataForm(this.warehouseData, this.warehouse);
        this.warehouseData.patchValue({
            support_condition_central: this.warehouse.support_condition_central,
            slope_1: this.warehouse.slope_1,
            slope_2: this.warehouse.slope_2,
            column_height: this.warehouse.column_height,
            width_1: this.warehouse.width_1,
            width_2: this.warehouse.width_2
        });
        this.warehouseData.valueChanges.subscribe(values => this.onValueChanged());
        this.isChanged = false;
    }

    private onValueChanged() {
        this.warehouseFormService.updateFormMessages(this.warehouseData, this.formErrors, this.validationMessages);
        if (this.warehouseData.value.total_length % this.warehouseData.value.frame_distance != 0) {
                this.formErrors.total_length = this.validationMessages.total_length.required;
            }
        this.updateWarehouse();
        this.isChanged = !this.isChanged;
    }

    updateWarehouse() {
        this.warehouseFormService.updateWarehouse(this.warehouse, this.warehouseData);
        this.warehouse.support_condition_central = this.warehouseData.value.support_condition_central;
        this.warehouse.slope_1 = this.warehouseData.value.slope_1;
        this.warehouse.slope_2 = this.warehouseData.value.slope_2;
        this.warehouse.column_height = this.warehouseData.value.column_height;
        this.warehouse.width_1 = this.warehouseData.value.width_1;
        this.warehouse.width_2 = this.warehouseData.value.width_2;
    }

    changeFocus(input) {
        this.inputFocus = input;
    }

}



// WEBPACK FOOTER //
// ./src/app/project/project-form-components/warehouse-params-forms/warehouse2-params-form/warehouse2-params-form.component.ts